import React, { useState, useEffect } from 'react';
import Layout from '../shared/Layout';

// Componentes locales de preadmision_prueba (P.A.A.)
import HistorialAcademicoPruebaAdmision from './HistorialAcademicoPruebaAdmision';
import AsignaturasPruebaAdmision from './AsignaturasPruebaAdmision';

const DashboardPreadmisionPrueba = ({ onLogout }) => {
    const [activeMenu, setActiveMenu] = useState('asignaturas');
    const [userInfo, setUserInfo] = useState({ userName: '', userRole: '' });

    // Menús para preadmision_prueba - Orden: Inscripción Asignaturas, Historial Académico
    const menuItems = [
        { id: 'asignaturas', label: 'Inscripción Asignaturas' },
        { id: 'historial', label: 'Historial Académico' }
    ];

    useEffect(() => {
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        setUserInfo({
            userName: user.nombre_completo || user.username || 'Usuario',
            userRole: 'Estudiante - Prueba de Admisión'
        });
    }, []);

    const renderContent = () => {
        switch (activeMenu) {
            case 'asignaturas':
                return <AsignaturasPruebaAdmision />;
            case 'historial':
                return <HistorialAcademicoPruebaAdmision />;
            default:
                return <AsignaturasPruebaAdmision />;
        }
    };

    return (
        <Layout
            userName={userInfo.userName}
            userRole={userInfo.userRole}
            menuItems={menuItems}
            onLogout={onLogout}
            activeMenu={activeMenu}
            setActiveMenu={setActiveMenu}
        >
            {renderContent()}
        </Layout>
    );
};

export default DashboardPreadmisionPrueba;

